import * as React from "react";
import { useState } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import axios from "axios";
import { ContextData } from "../../../../context/Context";
import baseUrl from "../../../../BaseURL";
import IconView from "../FontIcons/IconView";
import ApplicantProfileTabs from "../ApplicantProfile/ApplicantProfileTabs";
import Avatar from "@mui/material/Avatar";
import GetPersonData from "../../../../context/GetPersonData";

export default function ViewDialog(props) {

  const [open, setOpen] = React.useState(false);
  const {usertoken} = props;
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const [QualificationList, setQualificationList] = React.useState(null);
  const { AdministratorTokens } = React.useContext(ContextData);

  // Get List of Qualification from the server

  React.useEffect(() => {
   
  }, []);

  return (
    <div className="appicant-profile-dialog-con w-500rem ">
      <Button variant="contained" onClick={handleClickOpen}>
        <IconView
          tooltipText="View Applicants Profile"
          tooltipColor="white"
          tooltipIconSize="19px"
        />
      </Button>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      //  sx={{ "& .MuiDialog-paper": { width: "1000px", maxWidth: "1000px" } }}
        fullWidth
        maxWidth=""
      >
        <DialogContent>
          <ApplicantProfileTabs usertoken={usertoken} />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          {/* <Button onClick={handleClose} autoFocus>
            Agree
          </Button> */}
        </DialogActions>
      </Dialog>
    </div>
  );
}
